<template>
  <div @click="toggleOpen">
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div>
        <feather-icon
          icon="BellIcon"
          class="cursor-pointer mt-1 sm:mr-6 mr-2"
          :badge="notificationsCount"
        />
      </div>

      <vs-dropdown-menu
        class="notification-dropdown dropdown-custom vx-navbar-dropdown"
      >
        <div class="notification-top text-center p-5 bg-primary text-white">
          <h3 v-if="notificationsCount === 0" class="text-white">
            Aucun nouveau retour
          </h3>
          <h3 v-if="notificationsCount === 1" class="text-white">
            {{ notificationsCount }} nouveau retour
          </h3>
          <h3 v-else class="text-white">
            {{ notificationsCount }} nouveaux retours
          </h3>
          <p class="opacity-75">Détails dans les transactions</p>
        </div>

        <VuePerfectScrollbar
          ref="mainSidebarPs"
          class="scroll-area--nofications-dropdown p-0 mb-10"
          :settings="settings"
          :key="$vs.rtl"
        >
          <ul class="bordered-items">
            <li
              v-for="ntf in notifications"
              :key="ntf.index"
              class="flex justify-between px-4 py-4 notification cursor-pointer"
            >
              <div class="flex items-start">
                <feather-icon
                  :icon="ntf.icon"
                  :svgClasses="[
                    `text-${ntf.category}`,
                    'stroke-current mr-1 h-6 w-6',
                  ]"
                ></feather-icon>
                <div class="mx-2">
                  <span
                    class="block notification-title"
                    :class="[`text-${ntf.category}`, `font-${ntf.font}`]"
                    >{{ ntf.title }}</span
                  >
                  <small>{{ ntf.msg }}</small>
                </div>
              </div>
              <div class="flex items-center">
                <small class="mt-1 whitespace-no-wrap mx-2">{{
                  elapsedTime(ntf.time)
                }}</small>
                <feather-icon
                  icon="Trash2Icon"
                  svgClasses="h-5 w-5 hover:text-danger cursor-pointer mx-2"
                  @click="deleteNotification(ntf)"
                />
              </div>
            </li>
          </ul>
        </VuePerfectScrollbar>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      show: false,
      unreadNotifications: [
        {
          index: 0,
          title: "New Message",
          msg: "Are your going to meet me tonight?",
          icon: "MessageSquareIcon",
          time: this.randomDate({ sec: 10 }),
          category: "primary",
        },
        {
          index: 1,
          title: "New Order Recieved",
          msg: "You got new order of goods.",
          icon: "PackageIcon",
          time: this.randomDate({ sec: 40 }),
          category: "success",
        },
        {
          index: 2,
          title: "Server Limit Reached!",
          msg: "Server have 99% CPU usage.",
          icon: "AlertOctagonIcon",
          time: this.randomDate({ min: 1 }),
          category: "danger",
        },
        {
          index: 3,
          title: "New Mail From Peter",
          msg: "Cake sesame snaps cupcake",
          icon: "MailIcon",
          time: this.randomDate({ min: 6 }),
          category: "primary",
        },
        {
          index: 4,
          title: "Bruce's Party",
          msg: "Chocolate cake oat cake tiramisu",
          icon: "CalendarIcon",
          time: this.randomDate({ hr: 2 }),
          category: "warning",
        },
      ],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  computed: {
    notificationsCount() {
      return this.$store.getters.getNotificationsCount;
    },
    notifications() {
      return this.$store.getters.getNotifications.map((notification, index) => {
      if (notification.product) {
        return {
          _id: notification._id,
          index: index,
          title: `${notification.product.ref} - ${notification.product.name}`,
          msg: `Client: ${notification.product.client.full_name}`,
          time: notification.createdAt,
          icon: notification.read ? "" : "PackageIcon",
          font: notification.read ? "small" : "bold",
          category: notification.read ? "dark" : "danger",
        };
      } else {
        return {
          _id: notification._id,
          index: index,
          title: "Unknown Product",
          msg: "Client: Unknown Client",
          time: notification.createdAt,
          icon: notification.read ? "" : "PackageIcon",
          font: notification.read ? "small" : "bold",
          category: notification.read ? "dark" : "danger",
        };
      }
    });
    },
  },
  methods: {
    async toggleOpen() {
      this.show = !this.show;
      if (!this.show) {
        await this.$store.dispatch(
          "UPDATE_NOTIFICATIONS",
          this.$store.getters.getNotifications.filter(
            (notification) => !notification.read
          )
        );
      }
    },
    async deleteNotification(notification) {
      await this.$store.dispatch("DELETE_NOTIFICATION", notification);
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? " Years " : " Year ") + "ago";
      } else if (days > 0) {
        return days + (days > 1 ? " Days " : " Day ") + "ago";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " Hrs " : " Hour ") + "ago";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? " sec ago" : "just now");
      }

      return "Just Now";
    },
    randomDate({ hr, min, sec }) {
      let date = new Date();

      if (hr) date.setHours(date.getHours() - hr);
      if (min) date.setMinutes(date.getMinutes() - min);
      if (sec) date.setSeconds(date.getSeconds() - sec);

      return date;
    },
  },
  async beforeMount() {
    await this.$store.dispatch("NOTIFICATIONS_REQUEST");
    await this.$store.dispatch("UNREAD_NOTIFICATIONS_COUNT_REQUEST");
  },
};
</script>
